import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavLink } from 'react-router-dom';
import routes from '../routes';

import logo from '../assets/images/logo.png';
import Burger from './Burger';

const mapStateToProps = ({ settings, allPage }) => {
  return {
    settings,
    allPage
  };
};

const actions = {};

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};
class Navigation extends Component {
  state = {
    openMenu: false
  };
  openNav = () => {
    this.setState({ openMenu: true });
    document.body.classList.add('stop-scrolling');
  };

  closeNav = () => {
    this.setState({ openMenu: false });
    document.body.classList.remove('stop-scrolling');
  };

  handleHamburger = () => {
    const { openMenu } = this.state;

    if (openMenu) {
      this.closeNav();
    } else {
      this.openNav();
    }
  };

  getRouteNames = () => {
    const { allPage } = this.props;
    const homeWP = _.map(allPage, (value, key) => {
      const data = _.map(value, (i) => {
        const result = {
          key: _.get(i, 'slug'),
          [key]: _.get(i, 'title.rendered'),
        };
        return result;
      });
      return {
        key,
        ...data,
      };
    });
    const homeKey = _.keyBy(homeWP, 'key');
    const merged = _.merge(_.keyBy(_.get(homeKey, 'en'), 'key'), _.keyBy(_.get(homeKey, 'th'), 'key'));
    const values = _.values(merged);
    return _.map(routes, (val) => {
      const curSlug = _.chain(val.to)
        .split('/')
        .last()
        .value();
      const targetRoute = _.find(
        allPage,
        page => _.get(page, 'slug') === curSlug
      );
      return {
        ...val,
        // label: _.get(targetRoute, 'title.rendered', curSlug),
        label: {
          en: _.get(_.find((values), page => _.get(page, 'key') === _.get(targetRoute, 'title.rendered', curSlug)), 'en'),
          th: _.get(_.find((values), page => _.get(page, 'key') === _.get(targetRoute, 'title.rendered', curSlug)), 'th'),
        }
        // values: _.keyBy(values, 'key')
      };
    });
  };

  render() {
    const { openMenu } = this.state;
    const { changeLanguage, language, settings } = this.props;
    const routeNames = this.getRouteNames();
    return (
      <div
        className={`navigation ${
          openMenu ? 'open' : ''
        } row no-gutters align-items-center justify-content-between`}
      >
        <div className="logo">
          <NavLink to="/">
            <img src={logo} alt="logo" />
          </NavLink>
        </div>
        <div className="mobile hamburger">
          <button onClick={this.handleHamburger}>
            <Burger open={openMenu} />
          </button>
        </div>
        <div className={`mobile background ${openMenu ? 'open' : ''}`}>
          <div className="nav-options">
            <ul className="">
              {_.map(routeNames, (value) => {
                if (value.showMenu) {
                  return (
                    <li
                      aria-hidden
                      onClick={this.handleHamburger}
                      className=""
                      key={value.to}
                    >
                      <NavLink
                        exact={value.exact !== undefined ? value.exact : true}
                        to={value.to}
                        activeClassName="active"
                        className={
                          _.get(value, 'disabled', false) ? 'disabled' : ''
                        }
                      >
                        <h4
                          className="nav mobile navGold"
                          dangerouslySetInnerHTML={{
                            __html: _.get(value, `label.${language}`)
                            // __html: value.label
                          }}
                        />
                      </NavLink>
                    </li>
                  );
                }
                return '';
              })}
            </ul>
            <div className="row no-gutters align-items-center justify-content-between">
              <div className="row no-gutters contact">
                <a
                  className="contact-icon call"
                  href={`tel:${_.get(settings, 'tel')}`}
                >
                  <i className="icon-phone" />
                </a>
                <a
                  className="contact-icon call"
                  href={`mailto:${_.get(settings, 'email')}`}
                >
                  <i className="icon-mail" />
                </a>
                <a
                  className="contact-icon call"
                  href={`http://line.me/ti/p/~${_.get(settings, 'line')}`}
                >
                  <i className="icon-line" />
                </a>
              </div>
              <div className="row no-gutters language">
                <button
                  onClick={() => changeLanguage('th')}
                  className={`${
                    language === 'th' ? 'active' : ''
                  } language-icon th`}
                >
                  <h4 className="nav navGold">TH</h4>
                </button>
                <button
                  onClick={() => changeLanguage('en')}
                  className={`${
                    language === 'en' ? 'active' : ''
                  } language-icon en`}
                >
                  <h4 className="nav navGold">EN</h4>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="wrapper-link-menu">
          <ul
            className="row no-gutters"
            style={{ listStyleType: 'none', padding: 0 }}
          >
            {_.map(routeNames, (value) => {
              if (value.showMenu) {
                return (
                  <li className="link-menu" key={value.to}>
                    <NavLink
                      exact={value.exact !== undefined ? value.exact : true}
                      to={value.to}
                      activeClassName="active"
                      className={
                        _.get(value, 'disabled', false) ? 'disabled' : ''
                      }
                    >
                      <h4
                        className="nav navGold"
                        dangerouslySetInnerHTML={{
                          __html: _.get(value, `label.${language}`)
                          // __html: value.label
                        }}
                      />
                    </NavLink>
                  </li>
                );
              }
              return '';
            })}
          </ul>
        </div>

        <div className="nav-options">
          <div className="row no-gutters">
            <div className="contact">
              <a className="contact-icon call" href="tel:(+66)2 415 8000">
                <i className="icon-phone" />
              </a>
              <a
                className="contact-icon call"
                href={`mailto:${_.get(settings, 'email')}`}
              >
                <i className="icon-mail" />
              </a>
              <a
                className="contact-icon call"
                href={`http://line.me/ti/p/~${_.get(settings, 'line')}`}
              >
                <i className="icon-line" />
              </a>
            </div>
            <div className="language">
              <button
                onClick={() => changeLanguage('th')}
                className={`${
                  language === 'th' ? 'active' : ''
                } language-icon th`}
              >
                <h4 className="nav navGold">TH</h4>
              </button>
              <button
                onClick={() => changeLanguage('en')}
                className={`${
                  language === 'en' ? 'active' : ''
                } language-icon en`}
              >
                <h4 className="nav navGold">EN</h4>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation.js